import WeightInputMetric from './WeightInputMetric';

export default WeightInputMetric;
